module.exports = __webpack_public_path__ + "img/intro-sp-use.f568d1fd.jpg";